<template>
	<div class="d-flex">
		<InputText
			required
			v-model="inputValue"
			size="s"
			:placeholder="placeholder"
			:error="error"
			:label="label"
			:helper-text="helperText"
		>
			<template #selector="{ borderClass }">
				<Dropdown>
					<template #trigger>
						<div
							class="selected-option text-align-center height-full cursor-pointer rounded-l-2 border-xs border-neutral-200 px-4 py-3"
							:class="borderClass"
						>
							{{ selectedPrefix }}
						</div>
					</template>
					<template #default="{ close }">
						<div class="options-container overflow-y-auto cursor-pointer">
							<div
								v-for="prefix in prefixes"
								:key="prefix"
								class="option px-4 py-3"
								@click="() => selectPrefix(prefix, close)"
							>
								{{ prefix }}
							</div>
						</div>
					</template>
				</Dropdown>
			</template>
		</InputText>
	</div>
</template>

<script setup lang="ts">
	interface Props {
		placeholder?: string
		label?: string
		helperText?: string
		error?: string
	}
	defineProps<Props>()
	const inputValue = defineModel<string>()
	const selectedPrefix = defineModel<string>('selectedPrefix', {
		default: '+34',
	})

	const selectPrefix = (prefix: string, closeCallback: () => void): void => {
		selectedPrefix.value = prefix
		closeCallback()
	}

	const prefixes = [
		'+34',
		'+1',
		'+7',
		'+20',
		'+27',
		'+30',
		'+31',
		'+32',
		'+33',
		'+36',
		'+39',
		'+40',
		'+41',
		'+43',
		'+44',
		'+45',
		'+46',
		'+47',
		'+48',
		'+49',
		'+51',
		'+52',
		'+53',
		'+54',
		'+55',
		'+56',
		'+57',
		'+58',
		'+60',
		'+61',
		'+62',
		'+63',
		'+64',
		'+65',
		'+66',
		'+81',
		'+82',
		'+84',
		'+86',
		'+90',
		'+91',
		'+92',
		'+93',
		'+94',
		'+95',
		'+98',
		'+212',
		'+213',
		'+216',
		'+218',
		'+220',
		'+233',
		'+234',
		'+242',
		'+244',
		'+249',
		'+251',
		'+254',
		'+255',
		'+256',
		'+260',
		'+263',
		'+351',
		'+352',
		'+353',
		'+354',
		'+355',
		'+358',
		'+359',
		'+370',
		'+371',
		'+372',
		'+380',
		'+381',
		'+385',
		'+420',
		'+421',
		'+502',
		'+503',
		'+504',
		'+505',
		'+506',
		'+507',
		'+591',
		'+593',
		'+595',
		'+598',
		'+852',
		'+853',
		'+855',
		'+856',
		'+880',
		'+886',
		'+960',
		'+961',
		'+962',
		'+963',
		'+964',
		'+965',
		'+966',
		'+967',
		'+968',
		'+971',
		'+972',
		'+973',
		'+974',
		'+975',
		'+976',
		'+977',
		'+994',
		'+995',
		'+998',
	]
</script>
<style lang="scss" scoped>
	.selected-option {
		height: 100%;
		border-right: 0;
		min-width: 70px;
		max-width: 70px;
	}
	.options-container {
		max-height: 200px;
	}
	.option:hover {
		background-color: var(--color-neutral-100);
	}
</style>
